import { TitleCard } from "@/components/catalog/TitleCard";

export const TitleGrid = ({ items, testId = "title-grid" }) => (
  <div data-testid={testId} className="grid grid-cols-2 min-[480px]:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-x-3 sm:gap-x-4 gap-y-6">
    {items.map((t) => <TitleCard key={t.slug} title={t} fluid />)}
  </div>
);

export const EmptyState = ({ icon: Icon, title, text, action, testId }) => (
  <div data-testid={testId} className="panel flex flex-col items-center justify-center text-center py-20 px-6">
    {Icon && <Icon className="h-10 w-10 text-[#D4AF37] mb-4" strokeWidth={1.4} />}
    <h3 className="font-display text-lg text-white tracking-[0.12em]">{title}</h3>
    <p className="mt-2 max-w-sm text-sm text-[#8B8B8B]">{text}</p>
    {action && <div className="mt-6">{action}</div>}
  </div>
);

export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="relative overflow-hidden">
    <div className="pointer-events-none absolute inset-x-0 top-0 h-[420px] bg-[radial-gradient(ellipse_at_20%_0%,rgba(212,175,55,0.13),transparent_60%)]" />
    <div className="relative mx-auto max-w-[1680px] px-4 sm:px-6 lg:px-10 pt-24 md:pt-36 pb-8">
      {eyebrow && <p className="eyebrow mb-3 flex items-center gap-3">{eyebrow}<span className="h-px w-14 bg-gradient-to-r from-[#D4AF37] to-transparent" /></p>}
      <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl gold-text tracking-[0.06em]">{title}</h1>
      {children}
    </div>
  </div>
);

export const Spinner = ({ testId = "loading-spinner" }) => (
  <div data-testid={testId} className="grid min-h-[50vh] place-items-center">
    <div className="h-12 w-12 rounded-full border-2 border-[#D4AF37]/20 border-t-[#FFD86A] animate-spin" />
  </div>
);
